import {useState} from "react";
import Invite from "./Invite.tsx";
import MembersModule from "./MembersModule.tsx";

export default function TeamInvite() {
    type DropdownProps = {
        label: string;
        component: JSX.Element;
    };
    const [dropdownItemIndex, setDropdownItemIndex] = useState(0);

    const dropdown: DropdownProps[] = [
        {label: "Members", component: <MembersModule/>},
        {label: "Invites", component: <Invite/>},
    ];

    return (
        <>
            <div>
                <div className="body-wrappe">
                    <div className="flex">
                        <div>
                            <div
                                data-current="Tab 1"
                                data-easing="ease"
                                data-duration-in="300"
                                data-duration-out="100"
                                className="w-tabs"
                            >
                                <div className="tabs-menu-2  w-tab-menu" role="tablist">
                                    {dropdown.map((item, index) => {
                                        return (
                                            <a
                                          
                                                data-w-tab={`Tab ${index + 1}`}
                                                className={`spec-tab w-inline-block w-tab-link ${
                                                    dropdownItemIndex == index && "activeTabBody"
                                                }`}
                                                id={`w-tabs-${index}-data-w-tab-${index}`}
                                                role="tab"
                                                aria-controls={`w-tabs-${index}-data-w-pane-${index}`}
                                                aria-selected="true"
                                                onClick={() => setDropdownItemIndex(index)}
                                            >
                                                <p className="text-xl">{item.label}</p>
                                            </a>
                                        );
                                    })}
                                </div>
                                {dropdown[dropdownItemIndex].component}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
